import axios from "axios";

/**
 * Safely extracts an error message from an Axios error or generic Error.
 * Handles FastAPI 422 validation errors where detail is an array of objects.
 * Falls back gracefully to message, detail, or the provided default.
 */
export function extractErrorMessage(
  error: unknown,
  defaultMessage: string = "Unknown error",
): string {
  // Handle Axios errors
  if (axios.isAxiosError(error)) {
    const data = error.response?.data as Record<string, unknown> | undefined;

    // Check for FastAPI validation error (detail as array)
    if (Array.isArray(data?.detail)) {
      // Extract the first validation error message
      const firstError = (data.detail as Array<Record<string, unknown>>)[0];
      if (firstError?.msg && typeof firstError.msg === "string") {
        return firstError.msg;
      }
      // Fallback: combine all error messages
      return (data.detail as Array<Record<string, unknown>>)
        .map((err) => err.msg || JSON.stringify(err))
        .join(", ");
    }

    // Check for detail as string
    if (typeof data?.detail === "string") {
      return data.detail;
    }

    // Check for message as string
    if (typeof data?.message === "string") {
      return data.message;
    }
  }

  // Handle generic Error
  if (error instanceof Error) {
    return error.message;
  }

  return defaultMessage;
}
